/**
 * lesson-plans/$id/index.tsx — Edit an existing lesson plan.
 *
 * Loads the plan via lessonPlanQuery(id) and renders the builder in
 * edit mode. Mutations on items/title/description hit the existing
 * lesson-plans API (Task 23). A "Lihat versi cetak" link in the page
 * header jumps to the A4 print view at `/lesson-plans/$id/print`.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { LessonPlanBuilder } from '../../../components/lessons/LessonPlanBuilder.js';
import { freshSessionQuery } from '../../../lib/api/queries.js';

export const Route = createFileRoute('/lesson-plans/$id/')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role !== 'tutor' || !user.isApprovedTutor) {
      throw redirect({ to: '/me' });
    }
    return null;
  },
  component: EditLessonPlanPage,
});

function EditLessonPlanPage() {
  const { id } = Route.useParams();
  return <LessonPlanBuilder planId={id} />;
}